/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrUpdateBalloonUserIdDto } from '../../models/dbr-update-balloon-user-id-dto';

export interface BalloonsControllerUpdateUserId$Params {
      body: DbrUpdateBalloonUserIdDto
}

export function balloonsControllerUpdateUserId(http: HttpClient, rootUrl: string, params: BalloonsControllerUpdateUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerUpdateUserId.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

balloonsControllerUpdateUserId.PATH = '/balloons/userid';
